// scienceContentList.js

const scienceContentList = {
    "流感": {
        article: "/proxy/s/zABpAjlzDf-Smkw7ANzXwA",
        video: "/20261014014847.mp4"
    },
    "HPV" :{
        article: "/HPV科普文章.webp",
        video: "/894_1742894893.mp4"
    },
    "CRC" :{
        article: "/proxy/s/ofIOLcjymf6_DB_iMOLaoQ",
        video: "/20251122220740.mp4"
    },
    "RSV" :{
        article: "/proxy/s/_UwSGs41xsDutt_ihCW3ng",
        video: "/rsv_20260921190100.mp4"
    }
};

export default scienceContentList;
